import {
  PollNewChannel,
  type PollNewChannelProps,
} from '@/true-fsd/features/AwaitNewChannel/PollNewChannel';
import {
  // ROOT_PATH,
  accountPath,
  useNewAccountChannelRequestContext,
} from '@/true-fsd/data/advertiser-account';
import { FigmaWhiteLayout } from '@/true-fsd/shared/ui/FigmaLayout';
import { useCallback } from 'react';

// import classes from './ChannelRequest.module.scss';

export type NewAccountChannelRequestPageProps = {
  // className?: string;
};
export const NewAccountChannelRequestPage =
  ({}: NewAccountChannelRequestPageProps) => {
    const { activeNewAccountChannelRequest } =
      useNewAccountChannelRequestContext();

    const onCancel: PollNewChannelProps['onCancel'] = useCallback(
      (navigate) => {
        void navigate('/');
      },
      [],
    );

    const onContinue = onCancel;

    const onAccount: NonNullable<PollNewChannelProps['onAccount']> =
      useCallback((navigate, { createdAccount, invite }) => {
        void navigate(accountPath(createdAccount, 'complete'), {
          state: invite,
        });
      }, []);

    return (
      <PollNewChannel
        RenderLayout={FigmaWhiteLayout}
        onCancel={onCancel}
        channelRequest={activeNewAccountChannelRequest}
        onAccount={onAccount}
        onContinue={onContinue}
      />
    );
  };
